// Keep newest first. Add new roles at the top.
// `highlights` are 2-3 short bullet points on what you actually did there.

export const experience = [
  {
    company: "IOPn",
    role: "Junior Software Engineer",
    location: "Remote",
    period: "Dec 2025 - Present",
    highlights: [
      "Designed and built the OPN Chain indexing architecture end to end, integrating Graph Node with Docker, PostgreSQL, and IPFS to support OPN Chain as a native network and serve indexed data to internal and external applications over a GraphQL API.",
      "Developed and deployed token vesting smart contracts for enterprise clients, configuring release schedules and verifying on-chain distribution.",
      "Built and maintain the backend for IOPn Learn, now serving 2,257,419 registered learners and 13,802,493 completed lessons, with 231,071,585 IOPN testnet rewards distributed.",
      "Built and maintain the public testnet faucet and a community engagement service, reducing bot claims on the faucet by 90%, and ran pre-release QA on the IOPn wallet across Android and Chrome extension builds.",
    ],
  },
  {
    company: "IOPn",
    role: "Zero-Knowledge Research Intern",
    location: "Remote",
    period: "Jul 2025 - Nov 2025",
    highlights: [
      "Built a production Web3 authentication flow integrating Semaphore Zero-Knowledge proofs with Google OAuth 2.0 through Next.js API routes, enabling Web2 social sign-in without exposing identity on-chain.",
    ],
  },
  {
    company: "NullClass",
    role: "Web Developer",
    location: "Remote",
    period: "Jul 2024 - Sept 2024",
    // TODO: NullClass runs project-based MERN internships — these bullets
    // are inferred from that structure, not your specifics. Replace with
    // what you actually built if you recall it.
    highlights: [
      "Completed a project-based MERN stack internship, building web applications end-to-end within fixed sprint deadlines.",
      "Applied React, Node.js, Express, and MongoDB across multiple internship projects as part of NullClass's hands-on training program.",
    ],
  },
  {
    company: "Haqto Technologies",
    role: "Front-end Developer",
    location: "Coimbatore",
    period: "Jul 2024 - Aug 2024",
    // TODO: Haqto builds crypto wallets and payment gateways for clients —
    // these bullets are inferred from that focus, not your specifics.
    // Replace with what you actually built if you recall it.
    highlights: [
      "Built front-end interfaces for blockchain-based products, in line with Haqto's focus on crypto wallet and payment gateway development.",
      "Worked with the development team to turn blockchain product requirements into clean, responsive UI.",
    ],
  },
];
